var map = {
	"./feature_buy_bonus_cn.png": "f9fc",
	"./feature_buy_bonus_en.png": "cdad",
	"./feature_buy_bonus_id.png": "1ddf",
	"./feature_buy_bonus_ko.png": "9970",
	"./feature_buy_bonus_ph.png": "756d",
	"./feature_buy_bonus_th.png": "3723",
	"./feature_buy_bonus_zh.png": "5bef"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "207c";